import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const EnrollmentInformation: RouteConfig = {
  path: '/enrollment-information',
  component: Layout,
  redirect: 'noredirect',
  name: 'GeneralRulesMenu',
  meta: {
    title: 'enrollmentinformation',
    permission: 'GeneralRulesMenu',
    icon: 'guide'
  },
  children: [{
    path: 'enrollment-information/index',
    component: () => import(/* webpackChunkName: "BriefContents" */ '@/views/enrollmentinformation/enrollmentinformation/index.vue'),
    name: 'BriefContents',
    meta: {
      title: 'enrollmentinformation',
      permission: 'BriefContents',
      noCache: true,
      icon: 'enroll-info'
    }
  },
  {
    path: '/enrollment-information/dataset/index',
    component: () => import(/* webpackChunkName: "dataset" */ '@/views/enrollmentinformation/enrollmentinformation/dataset/index.vue'),
    name: 'dataset',
    meta: {
      title: 'dataset',
      activeMenu: '/enrollment-information/enrollment-information/index',
      hidden: true,
      noCache: true,
      icon: 'guide'
    }
  },
  {
    path: 'advertising-list/index',
    component: () => import(/* webpackChunkName: "advertisinglist" */ '@/views/enrollmentinformation/advertisinglist/index.vue'),
    name: 'advertisinglist',
    meta: {
      title: 'advertisinglist',
      noCache: true,
      hidden: true,
      icon: 'guide'
    }
  },
  {
    path: '/enrollment-information/add-advertising/index',
    component: () => import(/* webpackChunkName: "addadvertising" */ '@/views/enrollmentinformation/advertisinglist/addadvertising/index.vue'),
    name: 'addadvertising',
    meta: {
      title: 'addadvertising',
      activeMenu: '/enrollment-information/advertising-list/index',
      hidden: true,
      noCache: true,
      icon: 'guide'
    }
  }]
}

export default EnrollmentInformation

// const EnrollmentInformation: RouteConfig = {
//   path: '/enrollment-information',
//   component: Layout,
//   redirect: 'noredirect',
//   name: 'enrollmentinformation',
//   meta: {
//     title: 'enrollmentinformation',
//     icon: 'peoples'
//   },
//   children: [{
//     path: '/enrollment-information/dataset/index',
//     component: () => import('@/views/enrollmentinformation/enrollmentinformation/index.vue'),
//     redirect: 'dataset',
//     name: 'information',
//     meta: {
//       alwaysShow: true,
//       title: 'enrollmentinformation'
//     },
//     children: [{
//       path: '/enrollment-information/dataset/index',
//       component: () => import('@/views/enrollmentinformation/enrollmentinformation/dataset/index.vue'),
//       name: 'dataset',
//       meta: {
//         title: 'dataset',
//         noCache: true
//       },
//     }]
//   },
//   {
//     path: '/enrollment-information/advertising-list/',
//     name: 'advertisinglist',
//     component: () => import('@/views/enrollmentinformation/advertisinglist/index.vue'),
//     redirect: 'addadvertising',
//     meta: {
//       alwaysShow: true,
//       title: 'advertisinglist'
//     },
//     children: [{
//       path: '/enrollment-information/add-advertising/index',
//       component: () => import('@/views/enrollmentinformation/advertisinglist/addadvertising/index.vue'),
//       name: 'addadvertising',
//       meta: {
//         title: 'addadvertising',
//         noCache: true
//       },
//     }]
//   }]
// }
